import { render, staticRenderFns } from "./ratings-received.vue?vue&type=template&id=3c109437&scoped=true"
import script from "./ratings-received.vue?vue&type=script&lang=js"
export * from "./ratings-received.vue?vue&type=script&lang=js"
import style0 from "./ratings-received.vue?vue&type=style&index=0&id=3c109437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c109437",
  null
  
)

export default component.exports